import { render, staticRenderFns } from "./ProjectRegistration.update.vue?vue&type=template&id=162ace04&scoped=true"
import script from "./ProjectRegistration.update.vue?vue&type=script&lang=js"
export * from "./ProjectRegistration.update.vue?vue&type=script&lang=js"
import style0 from "./ProjectRegistration.update.vue?vue&type=style&index=0&id=162ace04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162ace04",
  null
  
)

export default component.exports